package com.gsb.vyapar.bhagya.presentation.category.uistate

import com.gsb.vyapar.bhagya.domain.Business
import com.gsb.vyapar.bhagya.domain.Categories.D.Category
import com.gsb.vyapar.bhagya.domain.SubCategories.D.SubCategory
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.getState
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.updateState

data class CategoriesViewUiState(
    val title: String = "Categories",
    val addEditCategory: Category = Category(),
    val addEditSubCategory: SubCategory = SubCategory(),
    val selectCategory: String = "Select Category",
    val selectCategoryMenuOptions: List<String> = listOf(),
    val selectCategoryMenuSelectedIndex: Int = -1,
    val category: Category = Category(),
    val businessDetail: Business? = null,
) {
    fun setCategoryMenuOptions(selectCategoryMenuOptions: List<String>) {
        updateCategoriesViewUiState(this.copy(selectCategoryMenuOptions = selectCategoryMenuOptions))
    }

    fun setCategory(addEditCategory: Category?) {
        updateCategoriesViewUiState(this.copy(addEditCategory = addEditCategory ?: Category()))
    }

    fun setCategoryName(name: String) {
        updateCategoriesViewUiState(this.copy(addEditCategory = getAddEditCategory().copy(name = name)))
    }

    fun setCategoryImageUrl(imageUrl: String) {
        updateCategoriesViewUiState(this.copy(addEditCategory = getAddEditCategory().copy(imageUrl = imageUrl)))
    }

    fun setCategoryDeleted(deleted: Boolean) {
        updateCategoriesViewUiState(this.copy(addEditCategory = getAddEditCategory().copy(deleted = deleted)))
    }

    fun setSubCategory(addEditSubCategory: SubCategory?) {
        updateCategoriesViewUiState(this.copy(addEditSubCategory = addEditSubCategory ?: SubCategory()))
    }

    fun setSubCategoryName(name: String) {
        updateCategoriesViewUiState(this.copy(addEditSubCategory = getAddEditSubCategory().copy(name = name)))
    }

    fun setSubCategoryCategoryId(categoryId: Long) {
        updateCategoriesViewUiState(this.copy(addEditSubCategory = getAddEditSubCategory().copy(categoryId = categoryId)))
    }

    fun setSubCategoryCategoryMenuIndex(categoryMenuIndex: Int) {
        updateCategoriesViewUiState(this.copy(selectCategoryMenuSelectedIndex = categoryMenuIndex))
    }

    fun setSubCategoryDeleted(deleted: Boolean) {
        updateCategoriesViewUiState(this.copy(addEditSubCategory = getAddEditSubCategory().copy(deleted = deleted)))
    }

    fun updateCategory(category: Category?) {
        updateCategoriesViewUiState(this.copy(category = category ?: Category()))
    }

    fun updateBusinessDetail(businessDetail: Business?) {
        updateCategoriesViewUiState(this.copy(businessDetail = businessDetail))
    }
}

fun updateCategoriesViewUiState(categoriesViewUiState: CategoriesViewUiState) {
    updateState(getState().copy(categoriesViewUiState = categoriesViewUiState))
}

fun getCategoriesViewUiState(): CategoriesViewUiState {
    return getState().categoriesViewUiState
}

fun getAddEditCategory(): Category {
    return getState().categoriesViewUiState.addEditCategory
}

fun getAddEditSubCategory(): SubCategory {
    return getState().categoriesViewUiState.addEditSubCategory
}